// Updated src/components/common/LanguageSelector.js
import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useLanguage } from '../../contexts/LanguageContext';
import { getTranslations } from '../../languages';

function LanguageSelector() {
  const { language, changeLanguage } = useLanguage();
  const translations = getTranslations(language);
  const navigate = useNavigate();
  const location = useLocation();

  // Handler for language change
  const handleLanguageChange = (e) => {
    const newLanguage = e.target.value;
    const currentPath = location.pathname;
    
    // Update language in context
    changeLanguage(newLanguage);
    
    // Update URL to reflect language change
    // Remove current language prefix if it exists and add new language
    const pathWithoutLang = currentPath.replace(/^\/(en|de)/, '');
    const newPath = `/${newLanguage}${pathWithoutLang || ''}`;
    
    // Navigate to the new URL
    navigate(newPath);
  };

  return (
    <div className="language-selector">
      <select 
        value={language}
        onChange={handleLanguageChange}
        aria-label={translations.language.select}
      >
        <option value="en">{translations.language.en}</option>
        <option value="de">{translations.language.de}</option>
      </select>
    </div>
  );
}

export default LanguageSelector;